import {FC, memo} from 'react'
import {useTranslation} from 'react-i18next'
import {FaSearch} from 'react-icons/fa'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {REGARDING_OPTIONS, SECTOR_OPTIONS, SI_STATUS} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {setFilter, sipSelector} from '../../../redux/slices/sipSlices'
import * as TableUI from '../../../components/Table/Table'

interface RowFilterProps {
  role?: 'null' | 'anper' | 'admin' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
}

export const RowFilter: FC<RowFilterProps> = (props) => {
  const {t} = useTranslation()
  const iconSearch = <FaSearch size={16} color='gray' style={{padding: 0}} />
  const {filter} = useAppSelector(sipSelector)
  const {salesOrgOptions} = useSalesOrganization()
  const dispatch = useAppDispatch()

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilter({...filter, ...value}))
  }

  return (
    <TableUI.TRowFilter>
      <td>
        <TextInputV2
          icon={iconSearch}
          placeholder={t('No. SIP')}
          value={filter?.SIP_number ?? ''}
          onChange={({target}) => handleChange({SIP_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          icon={iconSearch}
          placeholder={t('Order Number')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => handleChange({po_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          icon={iconSearch}
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <Selection
          data={REGARDING_OPTIONS}
          icon={iconSearch}
          placeholder={t('order-perihal')}
          value={filter?.perihal ?? ''}
          onChange={(perihal) => handleChange({perihal})}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          icon={iconSearch}
          placeholder={t('Sektor')}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => handleChange({sector_id})}
        />
      </td>
      <td>
        <Selection
          data={salesOrgOptions}
          icon={iconSearch}
          placeholder='Sales Org'
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleChange({sales_org_code})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleChange({created_at: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('Tanggal Pengajuan')}
          startDate={filter?.estimate_date ?? ''}
          onChange={({startDate}) => handleChange({estimate_date: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('Start-Date')}
          startDate={filter?.from_date ?? ''}
          onChange={({startDate}) => handleChange({from_date: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('End-Date')}
          startDate={filter?.to_date ?? ''}
          onChange={({startDate}) => handleChange({to_date: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          icon={iconSearch}
          placeholder={t('Total Kuantum')}
          value={filter?.total_quantum}
          onChange={({target}) => handleChange({total_quantum: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          icon={iconSearch}
          placeholder={t('Total Price')}
          value={filter?.total_request_price ?? ''}
          onChange={({target}) => handleChange({total_request_price: target.value})}
        />
      </td>
      <td>
        <Selection
          data={SI_STATUS}
          icon={iconSearch}
          placeholder={'Status'}
          value={filter?.status?.toString() ?? ''}
          onChange={(status) => handleChange({status})}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TableUI.TRowFilter>
  )
}

RowFilter.defaultProps = {
  role: 'otorisator',
}

export default memo(RowFilter)
